module.exports = __webpack_public_path__ + "img/20210909_061740.44e0bd4e.jpg";